import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Dialog from "../../components/Dialog";
import Order from "../../components/Order";
import Empty from "../../components/Empty";
import Fire from "../../api/Fire";

const Index = (props) => {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState([]);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        if (!Fire.currentUser) return;
        const ods = await Fire._getOrders(Fire.currentUser.uid);
        setOrders(ods);
      } catch (error) {
        setType(2);
        setMessage(error.message);
        setVisible(true);
      } finally {
        setLoading((prev) => false);
      }
    })();

    window.document.title = t("orders");
  }, []);

  const renderItems = () => {
    if (loading) {
      return (
        <Col lg={12} className="mt-5 text-center">
          <div className="spinner-grow text-success mt-5" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </Col>
      );
    }

    if (!Fire.currentUser) {
      return (
        <Col lg={12} className="mt-5 text-center">
          <Empty text={t("noUser")} />
          <button className="btn btn-success" onClick={() => props.history.push("/login")}>
            {t("login")}
          </button>
        </Col>
      );
    }

    if (orders.length === 0) return <Empty text={t("empty")} />;

    return (
      <Col sm={12} className="mt-5">
        {orders.map((order, index) => (
          <Order key={index} order={order} />
        ))}
      </Col>
    );
  };
  return (
    <main className="mt-5">
      <p className="p mid-text">
        <span>{t("orders")}</span>
      </p>

      {renderItems()}

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </main>
  );
};

export default Index;
